// extracted by mini-css-extract-plugin
export default {"div__principal":"pageStyle_div__principal__C6ySI","div__card":"pageStyle_div__card__IqEsL","div__logo":"pageStyle_div__logo__rA0lH"};